<template>
  <div class="index">
    <!-- 选择查询条件 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="160px">
        <div class="input-box">
          <div>
            <el-form-item label="律师姓名：">
              <el-input v-model="filterForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="律师联系电话：">
              <el-input v-model="filterForm.l_phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="擅长诉讼类型：">
              <el-select v-model="filterForm.layType" multiple clearable placeholder="请选择">
                <el-option v-for="(x,i) in $fuwuData.laytype2" :key="i" :label="x" :value="x"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1" />
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="paging_data.currentPage=1,filterClick()" icon="el-icon-search">查询</el-button>
              <!-- <el-button @click="this.select">测试</el-button> -->
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 用户操作按钮 -->
    <div class="edit">
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" type="danger" @click="deletefuwuData('lvshi')">删除</el-button>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" max-height="550" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(x,i) in baseInfo" :key="i"
          :label="x.value" :prop="x.key"
          :fixed="i<=7" align="center"></el-table-column>
      </el-table>
      <paging :pagesData="paging_data" @set_page_number="get_page_number"></paging>
    </div>
    <!-- 添加数据时的弹框 -->
    <el-dialog
      title="律师信息" :visible.sync="centerDialogVisible" :modal="false" width="1400px"
      :close-on-click-modal="false" @close="close" center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">律师信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace" />
                        </el-form-item>
                        <el-form-item label="律师姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="执业证号：">
                          <el-input style="width:193px;" v-model="editForm.certNo"></el-input>
                        </el-form-item>
                        <el-form-item label="执业律所：">
                          <el-input style="width:193px;" v-model="editForm.l_group"></el-input>
                        </el-form-item>
                        <el-form-item label="律所规模：">
                          <el-input style="width:193px;" v-model="editForm.l_groupPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="职业年份：">
                          <el-input style="width:193px;" v-model="editForm.l_startYear"></el-input>
                        </el-form-item>
                        <el-form-item label="擅长诉讼类型">
                          <el-checkbox-group v-model="createLaytype">
                            <el-checkbox v-for="item in $fuwuData.laytype2" :label="item" :key="item">{{item}}</el-checkbox>
                          </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.l_phone"></el-input>
                        </el-form-item>
                        <el-form-item label="办公地址：">
                          <el-input style="width:193px;" v-model="editForm.l_wordAddress"></el-input>
                        </el-form-item>
                        <el-form-item label="视频简介">
                          <el-upload class="avatar-uploader"
                            :action="videoUploadUrl"
                            :file-list="videofileList"
                            :limit="1"
                            v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                            :on-progress="uploadVideoProcess"
                            :on-success="handleVideoSuccess"
                            :before-upload="beforeUploadVideo"
                            :on-remove="removeVideo">
                            
                            <video v-if="editForm.videoUrl" ref="video" :src="editForm.videoUrl" class="avatar video-avatar videoBox" controls="controls">您的浏览器不支持视频播放</video>
                            <i v-if="!editForm.videoUrl" class="el-icon-plus avatar-uploader-icon"></i>
                            <el-progress v-if="videoFlag == true"
                              type="circle" style="margin-top:7px;"
                              v-bind:percentage="videoUploadPercent"></el-progress>
                          </el-upload>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="律师头像：" >
													<div class="head-img">
														<el-upload
                              ref="uploadImg" list-type="picture-card" :class="{hide:isMax}"
                              :action="uploadUrl" :file-list="fileList" :limit="1" 
                              :on-success="imgAdd" :on-error="error" :on-change="change"
                              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible" :modal="false">
                              <img width="100%" :src="imageUrl1" alt="">
                            </el-dialog>
													</div>
												</el-form-item>
                        <el-form-item label="专长：">
                          <el-input style="width:193px;" v-model="editForm.l_professional"></el-input>
                        </el-form-item>
                        <el-form-item label="职务：">
                          <el-input style="width:193px;" v-model="editForm.l_title"></el-input>
                        </el-form-item>
                        <el-form-item label="性别：">
                          <el-select v-model="editForm.l_sex" placeholder="请选择">
                            <el-option v-for="(x,i) in $fuwuData.sex" :key="i" :label="x" :value="x"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="地区：">
                          <el-input style="width:193px;" v-model="editForm.l_area"></el-input>
                        </el-form-item>
                        <el-form-item label="位置描述：">
                          <el-input style="width:193px;" v-model="editForm.l_locationDesc"></el-input>
                        </el-form-item>
                        <el-form-item label="服务区域：">
                          <el-input style="width:193px;" v-model="editForm.l_serviceArea"></el-input>
                        </el-form-item>
                        <el-form-item label="介绍：">
                          <el-input :rows="6" type="textarea" placeholder="请输入内容" v-model="editForm.l_description" maxlength="2000" show-word-limit>
                          </el-input>
                        </el-form-item>
                        <el-form-item label="成功案例：">
                          <el-input :rows="6" type="textarea" placeholder="请输入内容" v-model="editForm.l_case" maxlength="2000" show-word-limit>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import mixins from '@/Mixins/mixin_3g48'
import mixins_headimg from '@/Mixins/mixin_3g48HeadImg.js'
export default {
  mixins: [mixins , mixins_headimg],
  data() {
    return {
      rules:{},
      videoUploadUrl:`${this.$api.imgUrl}/user/public/upload`,
      filterForm:{},
      editForm:{},
      selectRow: [], //选中的数据加入数组
      tableData: [], //表格中的数据
      filterLaytype:[],//用于筛选的律师服务类型
      createLaytype:[],//用于弹框的律师服务类型


      isMax:false,
      headImgId:'',//暂存头像图片id
      imageUrl1: '',//预览图的url
      dialogVisible: false,//预览图片默认不显示
      fileList:[],//头像上传时的文件列表

      videofileList:[],//视频文件上传列表
      videoFlag: false,//上传视频，是否显示进度条
      videoUploadPercent: '',//上传视频，进度条的进度，
      videoType:['video/mp4'],//视频上传支持的文件格式



      //表头
      baseInfo: [
        { key: 'province', value: '省' },
        { key: 'city', value: '市' },
        { key: 'county', value: '县' },
        { key: 'town', value: '镇' },
        { key: 'village', value: '村' },
        { key: 'name', value: '律师姓名' },
        { key: 'l_professional', value: '专长' },
        { key: 'l_phone', value: '联系电话' }, 
        { key: 'certNo', value: '执业证号' },
        { key: 'l_wordAddress', value: '办公地址' },
        { key: 'viewTime', value: '浏览次数' },
      ],
      centerDialogVisible: false, //控制添加数据窗口是否可见
      isCreate:false,//用于判断点击提交时,是创建信息,还是修改信息
    }
  },
  methods:{
    filterClick() {//点击查询之后=====拿到查询的条件和区域id
      let rD = {}
      rD = JSON.parse(JSON.stringify(this.filterForm))
      rD.pageNumber = this.paging_data.currentPage
      rD.name == ''? delete rD.name:''
      rD.l_phone == ''? delete rD.l_phone:''
      rD.layType.length == 0 ? delete rD.layType:''
      rD.beRequest = true
      console.log(rD)
      this.getAreaidAndData(rD)//获取查询的区域id 将区域id赋给筛选对象newFrom  并调用发送请求的方法获取数据
    },
    //获取数据
    getData(rD = {}) {
      rD.pageNumber = this.paging_data.currentPage
      rD.beRequest = true
      console.log('查询对象',rD)
      this.$api.util_search('lvshi', rD).then(res=> {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this.paging_data.total = res.data.size
          this.tableData = _R
          console.log('拿到渲染到表格的数据',this.tableData)
        } else { this._status(res.data) }
      })
    },
    //修改或提交
    submit() {
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {//创建律师
          let rD = {}
          this.editForm.imgUrl = this.headImgId
          this.editForm.layType = this.createLaytype
          rD = JSON.parse(JSON.stringify(this.editForm))
          rD.province = this.province
          rD.city = this.city
          rD.county = this.county
          rD.town = this.town
          rD.village = this.village
          console.log(rD)
          this.$api.util_create('lvshi', rD).then(res =>{
              if (res.data.status === 0) {
                this.$message.success('创建成功!')
                this.getData()
                //this.Filter_file({api:this.api,data:this.form,callback:_d => this.tableData = _d })
              } else { this._status(res.data) }
          })
        } else if (valid && this.isCreate === false) {
          let requestData = {}
          let mapList = [//以下属性是，发生改变的时候才传
            'name',//姓名
            'certNo',//执业证号
            'l_phone',//联系电话
            'l_group',//执业律所
            'l_groupPersons',//律所规模
            'l_startYear',//执业年份
            'layType',//擅长诉讼类型
            'l_wordAddress',//办公地址
            'l_professional',//专长
            'l_title',//职务
            'l_sex',//性别
            'l_area',//地区
            'l_locationDesc',//位置描述
            'l_serviceArea',//服务区域
            'l_description',//介绍
            'l_case',//成功案例
            'imgUrl',//头像
            'videoUrl',//视频
          ]
          let mapList2 = [//无论是否发生改变 都必须传
            'province',
            'city',
            'county',
            'town',
            'village',
          ]
          this.editForm.province = this.province
          this.editForm.city = this.city
          this.editForm.county = this.county
          this.editForm.town = this.town
          this.editForm.village = this.village
          this.editForm.imgUrl = this.headImgId
          this.editForm.layType = this.createLaytype
          mapList.forEach(o => {//将修改过的属性和值赋给requestData
            this.editForm[o] != this.selectRow[0][o] ? requestData[o] = this.editForm[o] : ''
          })
          mapList2.forEach(o => {//无论是否发生改动，都必须将完整的区域名发送过去
            requestData[o] = this.editForm[o]
          })
          requestData.id = this.selectRow[0].id
          this.$api.util_modify('lvshi', requestData).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.getData()
            } else { this._status(res.data) }
          })

        } else {
          return false
        }
      })
    },


    //视频上传之前
    beforeUploadVideo(file) {
      let fileSize = file.size / 1024 / 1024 < 500//限制文件大小
      if (this.videoType.indexOf(file.type) != -1) {//限制格式为mp4
        if (!fileSize) {//限制文件大小不超过500M
          this.$message.info('视频大小不能超过500MB')
          return false
        } else {
          this.$message.success('上传成功！')
        }
      } else {
        this.$message.info('目前仅支持mp4文件格式上传！')
        return false
      }
    },
    //视频上传时
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true//显示上传的进度条
      this.videoUploadPercent = file.percentage.toFixed(0) * 1//上传进度
    },
    //视频成功上传的回调
    handleVideoSuccess(response, file, fileList) {
      this.videoFlag = false//隐藏进度条
      this.videoUploadPercent = 0//进度重置为0
      if (file.status == 'success' ) {
        console.log(response)
        let videoId = JSON.parse(response.data).fileId//保存video的id，用于拼接
        this.$api.getPublicFileUrl().then(res => {
          if (res.data.status == 0) {
            this.publicFileUrl = res.data.data
            this.$set(this.editForm,'videoUrl',this.publicFileUrl + '/' + videoId)
            console.log(this.editForm.videoUrl)
          } else { this._status(res.data) }
        })
      } else {
        this.$message.info('上传失败，请重新上传')
      }
    },
    //视频移除之后的回调
    removeVideo(file, fileList) {
      this.videofileList = fileList
      this.editForm.videoUrl = ''
    },

    //多选框被选中时,将选中的数据集合赋值给数组
    handleSelectionChange(val) {
      this.selectRow = val
    },
  },
  watch:{
    centerDialogVisible(val) {
      !val ? this.createLaytype = [] : ''
    }
  },
  created() {
    this.isShowBtn('layer')//控制操作按钮的显示与隐藏
    this.init()
    //渲染地区下拉框
    this.getArea({ value: { areaId: 0 }, key: 0 })
  },
  mounted() {
    this.paging_data.pageSize = 40//一页显示的数据条数
  },
}
</script>

<style lang='scss' scoped>
/deep/ .hide .el-upload--picture-card {display: none;}
/deep/ .el-upload-list__item {transition: none !important;}
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
/deep/.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover{border-color: #409EFF;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 178px;height: 178px;line-height: 178px;text-align: center;}
</style>